import { classNames, tv } from "@opensea/ui-kit"
import type { ComponentPropsWithoutRef } from "react"
import { useItemView } from "../items/ItemViewProvider"
import { FilterLayoutToolbar } from "./FilterLayoutToolbar"

const filterLayoutToolbarItemViewVariants = tv({
  variants: {
    itemViewGroup: {
      grid: "mb-2 pb-2",
      table: "",
    },
  },
})

export function FilterLayoutItemViewToolbar({
  className,
  ...rest
}: ComponentPropsWithoutRef<typeof FilterLayoutToolbar>) {
  const { itemViewGroup } = useItemView()

  return (
    <FilterLayoutToolbar
      className={classNames(
        filterLayoutToolbarItemViewVariants({
          itemViewGroup,
        }),
        className,
      )}
      {...rest}
    />
  )
}
